import React from "react";

import {MuiIcon, MuiIconExternalProps} from './MuiIcon';

export const CloseIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
    return (
        <MuiIcon {...props}
                 ref={ref}
        >{'\ue5cd'}</MuiIcon>
    );
})
